import styled from "styled-components";

export const StyledIcon = styled.span`
  margin: 5px 10px 0px 0px;
  top: 3px;
  position: relative;
`;
